const messages = {
    bonus: {
        title: "Aperçu des crédits bonus",
        description:
            "Des bonus en euros sont attribués aux entreprises participantes sur la base des chiffres de ventes transmis.",
        lastMonth: "Mois précédent",
        currentMonth: "Mois en cours",
        totalCurrentYear: "Total année en cours",
        totalLastYear: "Total année précédente",
    },
    points: {
        title: "Aperçu des crédits points",
        period: "Année civile en cours ({year})",
        totalAwarded: "Total des points attribués",
        redeemed: "Points échangés",
        totalBalance: "Solde total des points",
        redemptionRate: "Part des points attribués qui ont été échangés",
        averageAwarded: "Moyenne des points attribués par pneu acheté",
        standardAwarded: "Points nets des lignes de vente calculées, retours inclus",
        bsPlusInclBooster: "Points des lignes de vente à quantité positive",
        perTire: "Points échangés par pneu acheté",
    },
    tires: {
        title: "Aperçu du nombre de pneus",
        description: "Pneus achetés par les clients",
        prevMonth: "Mois précédent",
        totalLastYear: "Total année précédente",
        purchaseIndirect: "Achats via grossiste (indirect)",
        purchaseDirect: "Achats via grossiste (direct)",
        totalCurrentYear: "Total année en cours",
        currentMonth: "Mois en cours",
    },
    participating: {
        title: "Aperçu des clients participants",
        description:
            "Les entreprises qui s'inscrivent sur BRIDGESTONE PLUS peuvent être associées via le numéro client.",
        total: "Total",
        newThisMonth: "Nouveaux ce mois-ci",
        newThisYear: "Nouveaux cette année",
        createdInCurrentMonth: "Créés ce mois-ci (par l'admin)",
        loginsCurrentYear: "Connexions cette année (après acceptation des CGU)"
    },
    brand: {
        title: "Marque",
        description: "Vos achats en détail",
        centerTitle: "Par\nmarque"
    },
    rim: {
        title: "Jante",
        centerTitle: "Par taille\nde jante"
    },
    tireGoals: {
        title: "Objectifs d'achats de pneus",
        subtitle: "Gagnez des points sur vos achats de pneus.",
        centerTitle: "Par\n taille de pneu",
        tiresRemaining: "Pneus restants",
        progressionTarget: "Objectif de progression : ",
        pointsEarnedPurchases: "points gagnés\n" + "sur vos \n" + "achats",
        pointsEarnedBoosters: "points gagnés \n" + "avec les \n" + "boosters ",
        purchasesDetail: "Vos achats en détail",
        cta: "En savoir plus sur vos points",
        pointsTitle: "Vos points",
        pointsSubtitle: "Points gagnés sur vos achats Bridgestone",
        achievementsTitle: "Vos réalisations ",
        achievementsSubtitle: "Votre engagement annuel :",
        achievementsSubtitle2: "pneus"
    },
    score: {
        title: 'Score',
        total: 'Total',
        credits: 'Crédits en',
        deductions: 'Déductions en',
        unlockedPoints: 'Points débloqués',
        pendingPoints: 'Points en attente',
    },
    boosterCcs: {
        title: "Animation Booster CCS",
        historyTitle: "Animation Booster CCS",
        historyDescription: "Tous vos résultats Booster CCS par période.",
        seeMore: "Voir plus",
        empty: "Aucun résultat Booster CCS disponible.",
        exploreResults: "Découvrez vos résultats",
        learnMechanics: "En savoir plus sur la mécanique",
        yourRealisation: "Vos réalisations",
        yourPoints: "Vos points",
        soldTyres: "Pneus vendus",
        receivedPoints: "Points gagnés",
        pointsBySales: "Points générés par vos ventes de pneumatiques Bridgestone",
        salesDetail: "Vos ventes en détail",
        tyreLimitInfo:
            "Un volume sell-out de minimum 50 pneumatiques des marques Bridgestone et/ou Firestone est requis pour chaque période de l’animation Booster",
        noSalesBreakdown: "Pas encore de détail des ventes pour cette période.",
        charts: {
            byBrand: "Par marque",
            bySize: "Par taille<br/>de jante",
        },
    },
    score_extended: {
        title1: "Solde de points",
        title2: "Bonus en euros",
        balance: "Solde des points",
        bonus_in_euro: "Bonus en euros",
        date: "Date",
        added_points: "Points ajoutés en",
        total_bands: "Total des paliers",
        goal: "Objectif",
        tyres_previous_year: "Pneus vendus l'an dernier",
        tyres_current_year: "Pneus vendus cette année",
        target_this_year: "Objectif de ventes cette année",
        bonus_this_year: "Bonus gagné (€)",
        loyal_minimum: "Niveau minimum de fidélité",
        bonus_multiplier: "Taux multiplicateur du bonus"
    },
    lastImport: {
        label:"Dernier import des chiffres de ventes :",
        on: "le"
    },
    wholesalerTable: {
        title: "Clients participants en détail",
        description:
            "Vous trouverez ci-dessous les entreprises inscrites sur BRIDGESTONE PLUS avec le numéro client de votre société. " +
            "Vous pouvez utiliser les filtres pour modifier le tri ou la recherche pour retrouver des clients.",
        columns: {
            customer_number: "N° client",
            address_company_name: "Entreprise",
            address_street: "Rue et numéro",
            address_postal_code: "Code postal",
            address_city: "Ville",
            last_registration: "Dernière inscription",
            network: "Réseau",
            profile_group: "Groupe",
            tires_amount: "Nombre de pneus",
            point_balance: "Solde de points",
            bonus: "Bonus",
            details: "Détails"
        },
        searchPlaceholder: "Rechercher"
    },
    dealerTable: {
        columns: {
            date: "Date",
            wholesaler_bs_plus: "Grossiste BS+",
            customer_number: "Numéro client",
            article: "Article",
            brand: "Marque",
            product: "Produit",
            type: "Type",
            inch: "Pouce",
            season: "Saison",
            amount: "Quantité",
            points: "Points",
            activity: "Activité",
            total_points: "Total des points"
        },
        title: "Tableau des distributeurs",
        description: "Aperçu des activités des distributeurs",
    },
    business_units: {
        title: "Unités commerciales",
        centerTitle: "Par\n unité",
    },
    season: {
        title: "Saison",
        centerTitle: "Par période\n de l'année",
    },
}

export default {
    messages,
};
